module.exports = __webpack_public_path__ + "8fcae8f52d46682400c0954119e03b77.png";